import { use } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
// config
import { defaultLang } from "./config";
// languages
// import languages from "./languages";
import en from "./en";

const i18n = use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // resources: Object.entries(languages).reduce((acc, [key, value]) => {
    //   return {
    //     ...acc,
    //     [key]: { translations: value },
    //   };
    // }, {}),
    partialBundledLanguages: true,
    resources: {
      en: { translations: en },
    },
    lng: localStorage.getItem("i18nextLng") || defaultLang.value,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
